import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Package, Clock, ShieldCheck } from 'lucide-react';
import { fetchSeguimientoPublico, SeguimientoPublico } from '../../../../services/correspondencia';
import { useTheme } from '../../../../context/ThemeContext';

const labels: Record<string, string> = {
    recibido: 'En recepción', notificado: 'Listo para retirar',
    entregado: 'Entregado', cancelado: 'Cancelado',
};
const date = (value: string | null) => value ? new Date(value).toLocaleString('es-BO') : 'Pendiente';

const SeguimientoPublicoPage: React.FC = () => {
    const { token } = useParams<{ token: string }>();
    const { isDark } = useTheme();
    const [item, setItem] = useState<SeguimientoPublico | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    useEffect(() => {
        let active = true;
        setLoading(true); setError(''); setItem(null);
        if (!token) { setError('El enlace de seguimiento está incompleto.'); setLoading(false); return; }
        fetchSeguimientoPublico(token).then(data => { if (active) setItem(data); })
            .catch(() => { if (active) setError('No encontramos la encomienda. Utiliza el enlace de seguimiento que recibiste.'); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [token]);
    return <main className="min-h-screen px-4 py-12" style={{background: isDark ? '#0b0614' : '#faf8fc', color: isDark ? '#f8fafc' : '#312039'}}>
        <section className="max-w-xl mx-auto rounded-3xl border p-8 shadow-lg" style={{background: isDark ? '#1a0b2e' : '#fff', borderColor: isDark ? '#61257b' : '#eadfee'}}>
            <Package size={40} className="text-[#c1348b] mb-4"/>
            <h1 className="text-2xl font-bold mb-2">Seguimiento de encomienda</h1>
            {loading ? <p role="status">Consultando estado…</p> : error ? <p role="alert">{error}</p> : item && <>
                <p className="mb-6">Código: <strong>{item.codigo}</strong></p>
                <p className="text-xl font-semibold mb-6">{labels[item.estado] || 'En proceso'}</p>
                <dl className="space-y-4"><div><dt className="flex gap-2 items-center"><Clock size={16}/>Recepción</dt><dd>{date(item.fecha_recepcion)}</dd></div>
                    <div><dt>Entrega</dt><dd>{date(item.fecha_entrega)}</dd></div></dl>
            </>}
            <p className="flex gap-2 mt-8 text-sm"><ShieldCheck size={20} className="shrink-0"/>El PIN de retiro y los documentos se consultan desde tu cuenta o en el comprobante privado que recibiste.</p>
            <Link className="inline-block mt-6 font-semibold text-[#c1348b]" to="/mi-correspondencia">Ir a mi correspondencia</Link>
        </section>
    </main>;
};
export default SeguimientoPublicoPage;
